import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";

const UpdateProfile = Loadable(
  lazy(() =>
    import("./../layout/MainLayout/Header/ProfileSection/UpdateProfile")
  )
);
const ChangePassword = Loadable(
  lazy(() =>
    import("./../layout/MainLayout/Header/ProfileSection/ChangePassword")
  )
);

//user route
const Dashboard = Loadable(lazy(() => import("views/Dashboard/Index")));
const Analytics = Loadable(lazy(() => import("views/Analytics/Index")));

const ReportedProperties = Loadable(
  lazy(() => import("views/ReportedProperties/Index"))
);
const Properties = Loadable(lazy(() => import("views/Properties/Index")));
const AddPropertyForm = Loadable(
  lazy(() => import("views/Properties/AddPropertyForm"))
);

const AddPropertyStepperForm = Loadable(
  lazy(() =>
    import("views/Properties/AddPropertyStepper/AddPropertyStepperForm")
  )
);
const PropertiesDetail = Loadable(
  lazy(() => import("views/Properties/PropertyTabPanel"))
);
const EditPropertyForm = Loadable(
  lazy(() => import("views/Properties/EditPropertyForm"))
);
const UpdatePropertyForm = Loadable(
  lazy(() => import("views/Properties/UpdatePropertyForm"))
);
const Notification = Loadable(lazy(() => import("views/Notification/Index")));

const ChatMainPage = Loadable(lazy(() => import("views/Chat/index.js")));
const RentalAgreementTemplate = Loadable(
  lazy(() => import("views/RentalAgreementTemplate/Index"))
);
const EditRentalAgreement = Loadable(
  lazy(() =>
    import("views/RentalAgreementTemplate/EditRentalAgreementTemplate")
  )
);
const CreateRentalAgreementTemplate = Loadable(
  lazy(() =>
    import("views/RentalAgreementTemplate/CreateRentalAgreementTemplate")
  )
);
const ViewRentalAgreementTemplate = Loadable(
  lazy(() =>
    import("views/RentalAgreementTemplate/ViewRentalAgreementTemplate")
  )
);
const PreviewRentalAgreement = Loadable(
  lazy(() => import("views/RentalAgreementTemplate/PreviewRentalAgreement"))
);
const UserSupport = Loadable(lazy(() => import("views/UserSupport/Index")));
const ViewUserSupport = Loadable(
  lazy(() => import("views/UserSupport/ViewUserSupport/index"))
);
const CreateSupportTicket = Loadable(
  lazy(() => import("views/UserSupport/CreateSupportTicket.js"))
);
const PurchaseAds = Loadable(
  lazy(() => import("views/PurchaseAds/PurchaseAds"))
);
const ByAccessToRentalList = Loadable(
  lazy(() => import("views/ByAccessToRentalList/Index"))
);
const Applications = Loadable(lazy(() => import("views/Applications/Index")));
const ApplicationDetails = Loadable(
  lazy(() => import("views/Applications/ApplicationDetails"))
);
const ApplicationUserDetails = Loadable(
  lazy(() => import("views/Applications/ApplicantUserDetails"))
);
const Subscription = Loadable(
  lazy(() => import("views/Subscription/Subscription"))
);
const TenantList = Loadable(lazy(() => import("views/TenantList/TenantList")));
const ViewTenantList = Loadable(
  lazy(() => import("views/TenantList/ViewTenantList"))
);
const SubscriptionHistory = Loadable(
  lazy(() => import("views/Subscription/SubscriptionHistory"))
);

const RentalService = Loadable(lazy(() => import("views/RentalService/Index")));
const RentalServiceDetail = Loadable(
  lazy(() => import("views/RentalService/ViewRentalService"))
);
const RequestRentalService = Loadable(
  lazy(() => import("views/Properties/RequestRentalService"))
);
const AllProperties = Loadable(
  lazy(() => import("views/AllProperties/AllProperties"))
);
const AllPropertiesDetail = Loadable(
  lazy(() => import("views/AllProperties/AllPropertiesDetails"))
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/all-properties",
      element: <AllProperties />,
    },
    {
      path: "/all-properties/view/:id",
      element: <AllPropertiesDetail />,
    },
    {
      path: "/purchase-ads",
      element: <PurchaseAds />,
    },
    {
      path: "/access-rental-list",
      element: <ByAccessToRentalList />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/analytics",
      element: <Analytics />,
    },
    {
      path: "/properties",
      element: <Properties />,
    },
    {
      path: "/properties/view/:id",
      element: <PropertiesDetail />,
    },
    {
      path: "/property/edit/:id",
      element: <EditPropertyForm />,
    },
    {
      path: "/property/add",
      element: <AddPropertyForm />,
    },
    {
      path: "/property/register",
      element: <AddPropertyStepperForm />,
    },
    // {
    //   path: "/property/update/:id",
    //   element: <AddPropertyStepperForm />,
    // },
    {
      path: "/property/update/:id",
      element: <UpdatePropertyForm />,
    },
    {
      path: "/applications",
      element: <Applications />,
    },
    {
      path: "/applications/view/:id",
      element: <ApplicationDetails />,
    },
    {
      path: "/application/user-details",
      element: <ApplicationUserDetails />,
    },
    {
      path: "/chat/:id",
      element: <ChatMainPage />,
    },
    {
      path: "/chat",
      element: <ChatMainPage />,
    },
    {
      path: "/rental-agreement-template",
      element: <RentalAgreementTemplate />,
    },
    {
      path: "rental-agreement-template/add",
      element: <CreateRentalAgreementTemplate />,
    },
    {
      path: "/rental-agreement-template/edit/:id",
      element: <EditRentalAgreement />,
    },
    // {
    //   path: "/rental-agreement-template/view/:id",
    //   element: <ViewRentalAgreementTemplate />,
    // },
    {
      path: "/rental-agreement-template/preview/:id",
      element: <PreviewRentalAgreement />,
    },
    {
      path: "/staff-support",
      element: <UserSupport />,
    },
    {
      path: "/staff-support/:selectedPage",
      element: <UserSupport />,
    },
    {
      path: "/staff-support/view/:id",
      element: <ViewUserSupport />,
    },
    {
      path: "/staff-support/view/:id/:page",
      element: <ViewUserSupport />,
    },
    {
      path: "/create-support-ticket",
      element: <CreateSupportTicket />,
    },

    {
      path: "/reported-properties",
      element: <ReportedProperties />,
    },

    {
      path: "/notification",
      element: <Notification />,
    },

    {
      path: "/update-profile",
      element: <UpdateProfile />,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/subscription",
      element: <Subscription />,
    },
    {
      path: "/tenant-list",
      element: <TenantList />,
    },
    {
      path: "/tenant-list/view/:id",
      element: <ViewTenantList />,
    },
    {
      path: "/subscription-history",
      element: <SubscriptionHistory />,
    },
    {
      path: "/rental-service",
      element: <RentalService />,
    },
    {
      path: "/rental-service/view/:id",
      element: <RentalServiceDetail />,
    },
    {
      path: "/request-rental-service/:id",
      element: <RequestRentalService />,
    },
  ],
};

export default MainRoutes;
